import { LocalStorageKey } from "@shared/config/local-storage-key";
import { LOGIN_NONE } from "@shared/config/constants";
import { deleteCookie } from "@shared/utils/delete-cookie";
import { closeAllWebSockets } from "@shared/lib/socket/websocket";

/**
 * 세션 종료(로그아웃/세션 무효) 시 정리 일원화.
 * - 열려있는 실시간 소켓을 닫는다(세션 무효 후 소켓 잔존 방지 — WebSocket 은 localStorage 토큰을 쓰므로 별도 정리 필요).
 * - 인증 관련 localStorage 키만 제거(무관한 키는 보존) + LOGIN_STATE 를 LOGIN_NONE 으로.
 * - 과거 reissue 가 심었던 레거시 인증 쿠키(accessToken/refreshToken) 삭제.
 *   (현재는 쿠키를 쓰지 않는다 — WebSocket 도 localStorage 토큰을 서브프로토콜로 전달.)
 * 모든 로그아웃 경로(interceptor·reissue·logout·not-found)에서 이 함수를 사용한다.
 */
export const clearSession = () => {
    closeAllWebSockets();

    localStorage.removeItem(LocalStorageKey.AUTHORIZATION);
    localStorage.removeItem(LocalStorageKey.RE_AUTHORIZATION);
    localStorage.removeItem(LocalStorageKey.ROLE_TYPE);
    localStorage.setItem(LocalStorageKey.LOGIN_STATE, LOGIN_NONE);

    deleteCookie("accessToken");
    deleteCookie("refreshToken");
};
